import { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { AuthShell, AuthIcon } from '../../components/layout/AuthShell';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Ungültiger Verifizierungslink');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await axios.post(`${API}/auth/verify-email?token=${token}`);

        if (response.data.access_token) {
          localStorage.setItem('token', response.data.access_token);
          localStorage.setItem('user', JSON.stringify(response.data.user));
        }

        setStatus('success');
        setMessage('Deine E-Mail wurde erfolgreich bestätigt!');

        setTimeout(() => {
          window.location.href = '/freischaltung-ausstehend';
        }, 2000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Verifizierung fehlgeschlagen');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <AuthShell
      testId="verify-email-page"
      eyebrow="E-Mail-Bestätigung"
      title={<>Deine E-Mail <span className="serif-it text-purple">wird geprüft.</span></>}
    >
      <div className="text-center">
        {status === 'loading' && (
          <div data-testid="verify-email-loading">
            <Loader2 className="w-16 h-16 text-purple mx-auto mb-4 animate-spin" />
            <h2 className="text-xl font-bold mb-2">E-Mail wird verifiziert...</h2>
            <p className="text-ink/80">Bitte warte einen Moment.</p>
          </div>
        )}

        {status === 'success' && (
          <div data-testid="verify-email-success">
            <AuthIcon tone="green"><CheckCircle2 className="w-8 h-8" /></AuthIcon>
            <h2 className="text-xl font-bold mb-2">Erfolgreich!</h2>
            <p className="text-ink/80 mb-4">{message}</p>
            <p className="text-sm text-ink/60">Du wirst weitergeleitet...</p>
          </div>
        )}

        {status === 'error' && (
          <div data-testid="verify-email-error">
            <AuthIcon tone="red"><XCircle className="w-8 h-8" /></AuthIcon>
            <h2 className="text-xl font-bold mb-2">Verifizierung fehlgeschlagen</h2>
            <p className="text-ink/80 mb-6">{message}</p>
            <div className="flex flex-col gap-3">
              <Button asChild className="btn--block">
                <Link to="/register">Erneut registrieren</Link>
              </Button>
              <Button asChild variant="outline" className="btn--block">
                <Link to="/login">Zum Login</Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </AuthShell>
  );
};

export default VerifyEmailPage;
